/**
 * Chat facade — delegates to Chatwoot or Crisp depending on which is loaded.
 * The Blade template loads one or the other based on CHATWOOT_WEBSITE_TOKEN env var.
 */

import { openChat as openChatwoot, hideChat as hideChatwoot, isChatwootAvailable } from './chatwoot';
import { openCrispChat, hideCrispChat } from './crisp';

export function openChat(message?: string, userEmail?: string, userName?: string): void {
  if (isChatwootAvailable()) {
    openChatwoot(message);
  } else {
    openCrispChat(message, userEmail, userName);
  }
}

export function hideChat(): void {
  if (isChatwootAvailable()) {
    hideChatwoot();
  } else {
    hideCrispChat();
  }
}
